import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import animated from "animate.css";
import "./assets/public.css";
import "default-passive-events";
import 'vant/es/dialog/style';
import {
  Swipe,
  SwipeItem,
  Dialog
} from "vant";

createApp(App)
  .use(store)
  .use(router)
  .use(animated)
  .use(Swipe)
  .use(SwipeItem)
  .use(Dialog)
  .mount("#app");

document.body.addEventListener(
  "touchmove",
  function (e) {
    e.preventDefault(); // 阻止默认的处理方式(阻止下拉滑动的效果)
  },
  { passive: false }
); //passive 参数不能省略，用来兼容ios和android

// router.beforeEach((to, from, next) => {
//   next();
//   let allowBack = true;
//   console.log(to.meta.allowBack);
//   if (to.meta.allowBack !== undefined) {
//     allowBack = to.meta.allowBack;
//   }
//   if (!allowBack) {
//     history.pushState(null, null, location.href);
//   }
//   store.commit("updateAppSetting", allowBack);
//   // window.history.replaceState(null, null, window.location.href);
// });
